import { redirect, useLoaderData } from 'react-router'
import type { LoaderFunctionArgs } from 'react-router'
import { TextLink } from '@/components/subscription/text-link'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import { FlowerCollectionProduct } from '~/api-client/data-contracts'

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url)
  const productId = url.searchParams.get('product_id')

  if (!productId) {
    return redirect('/subscription/rose/mypage/bulk')
  }

  const subscriptions = await fetchSubscriptions()
  const subscription = subscriptions.data.data[0]

  if (!subscription) {
    return redirect('/subscription/rose/mypage')
  }

  const product = await fetchProduct(subscription.id)
  const inBulkProduct = product?.data?.included?.find((item) => item.type === 'flower_collection_product' && item.id === productId)

  if (!inBulkProduct) {
    return redirect('/subscription/rose/mypage/bulk')
  }

  return inBulkProduct as unknown as FlowerCollectionProduct
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions({ category: 'rose' })
}

function fetchProduct(id: string) {
  return createClient(Subscriptions).getSubscriptionsSubscriptionIdProduct(id)
}

export const SubscriptionRoseMypageBulkDone: React.FC = () => {
  const product = useLoaderData<typeof loader>()

  const price = Intl.NumberFormat('ja-JP').format(product.attributes.bulk_discounted_price)

  return (
    <div className="flex flex-col items-center gap-10 pt-8">
      <div className="flex flex-col items-center gap-6">
        <h1 className="text-[22px] font-bold text-black leading-relaxed text-center">
          グッズのご注文
          <br />
          ありがとうございました！
        </h1>
        <div className="flex flex-col items-center gap-2">
          <img src={product.attributes.image_small_url} alt={product.attributes.name} className="w-40 h-40 object-cover rounded-2xl" />
          <p className="text-[14px] font-bold text-black leading-relaxed">{product.attributes.name}</p>
          <p className="text-[14px] text-black">{price}円</p>
        </div>
        <p className="text-[13px] text-[#828282] leading-relaxed text-center">グッズの代金は、次回の決済時にブーケ代金と合わせて請求されます。</p>
      </div>
      <TextLink to="/subscription/rose/mypage">マイページに戻る</TextLink>
    </div>
  )
}
